import script from "./SiderView.vue?vue&type=script&setup=true&lang=js"
export * from "./SiderView.vue?vue&type=script&setup=true&lang=js"

import "./SiderView.vue?vue&type=style&index=0&id=dc8e9b4e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc8e9b4e"]])

export default __exports__